define('lib/view_helpers/appFilterFormatter',['require','translate','underscore','backbone','lib/backbone/Backbone.PodioView','lib/Podio.Utils'],function (require) {

  var t = require('translate');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var podioUtils = require('lib/Podio.Utils');

  return ViewPodioBase.extend({

    initialize: function() {

      _.bindAll(this, 'getAvailableFilterValuesForPicker', 'getCurrentFilterValues');

      this.field = this.options.field;
      this.filterState = this.options.filterState;
      this.fieldValues = this.options.fieldValues;

      this._super();
    },

    getValue: function(item, value) {
      return item.get ? item.get(value) : item[value];
    },

    formatValueForPicker : function(value) {
      return {
        name: value.get('label'),
        id: value.get('value').id,
        value: value.get('value').id
      };
    },

    formatCurrentValuesForDateFields : function(currentFilterValues) {

      var pickerValues = [];
      var filterValue = null;

      if(!currentFilterValues) {
        return pickerValues;
      }


      // Always first value for date-fields
      if(currentFilterValues) {
        // Better check for an Array before accessing stuff?
        filterValue = Array.isArray(currentFilterValues) ? currentFilterValues[0].value : currentFilterValues.value;
      }

      var isFilterCustomDate = this.fieldValues.isFilterCustomDate(filterValue);

      var formattedToValue = ( filterValue && filterValue['to'] ) ? filterValue['to'] : '...';
      var formattedFromValue = ( filterValue && filterValue['from'] ) ? filterValue['from'] : '...';

      if(isFilterCustomDate) {

        pickerValues.push(
          {
            label: '{0} - {1}'.format(formattedFromValue, formattedToValue),
            value: {
              id: filterValue
            }
          }
        );

      } else {

        if(filterValue && filterValue) {

          var value = this.fieldValues.toValue(filterValue);
          var valueModel = this.fieldValues.get(value);

          if(valueModel) {
            // Filter date state could be invalid ( { to: '', from: '' }), due to bad filter-data, so let's be sure. Remove this once filter values is cleaned up in the API.
            pickerValues = [
              {
                label: valueModel.get('name'),
                value: {
                  id: value
                }
              }
            ];
          } else {
            if(value == ":") {
              // `Not set` filter
              pickerValues = [{
                label: t('Not set #daterange'),
                value: {
                  id: filterValue
                }
              }];
            }else{
              pickerValues = [{
                label: t('Unknown interval #daterange'),
                value: {
                  id: filterValue
                }
              }];
            }
          }
        } else {
          pickerValues = [];
        }

      }

      return pickerValues;
    },

    formatCurrentValuesForRangeValues : function(currentFilterValues) {
      var pickerValues = [];

      if(currentFilterValues) {

        // Always first value.
        var filterValue = currentFilterValues[0].value;

        var fieldType = this.field.get('type');

        var fieldUnit;
        if (fieldType === 'progress') {
          fieldUnit = '%';
        } else if (fieldType === 'duration') {
          fieldUnit = t('hours #range');
        } else {
          fieldUnit = '';
        }

        var startValue = filterValue['from'];
        var endValue = filterValue['to'];

        pickerValues.push({
          label: (startValue !== null ? startValue + ' ' + fieldUnit : '') + ' ... ' + (endValue !== null ? endValue + ' ' + fieldUnit : ''),
          value: {
            id: filterValue
          }
        });
      }

      return pickerValues;
    },

    searchAvailableFilterValues : function(pickerValues, query) {
      var searchExpression = new RegExp(query, "gi");

      // Wrap as underscore-object, to ensure .each is present.
      return _(pickerValues.filter(function(value) {
          var name = String(value.get('label'));
          return name.search(searchExpression) !== -1;
      }));
    },

    getAvailableFilterValuesForPicker: function(mode, query, callback) {

      var pickerValues;
      var self = this;

      if(_.isFunction(this.fieldValues.search)) {
        // This field collection has search, so let's use that

        this.fieldValues.search(query).done(function(fieldValues) {
          callback(fieldValues.toJSON({ recursive: true }));
        });
      } else {
        pickerValues = this.fieldValues;

        // Filter out items not matching query
        if(query.length) {
          pickerValues = this.searchAvailableFilterValues(pickerValues, query);
        }

        var availableValues = this.handleGrouping(pickerValues);
        callback(availableValues);
      }

    },

    handleGrouping: function(pickerValues) {

      // Handle grouping
      var groups = {};
      var items = [];

      pickerValues.each(function(value) {

        var item = this.formatValueForPicker(value);

        if(value.get('group')) {

          if( !groups[value.get('group')]) {
            groups[value.get('group')] = {
              type: 'group',
              name : value.get('group'),
              id : value.get('group'),
              items: []
            };
          }

          groups[value.get('group')]['items'].push(item);

        } else {
          items.push(item);
        }

      }, this);

      var availableValues = items.concat( _.toArray(groups) );

      return availableValues;
    },

    getFormattedItem: function(item) {
      return new Backbone.Model(item);
    },

    getCurrentFilterValues: function() {

      var id = this.field.get('id');

      var currentFilterValues = typeof id === 'string' && id.indexOf(':') !== -1
            ? this.getValuesFromLocation(this.filterState, id)
            : this.filterState.getValuesByFieldId(id);

      // HACK: this.field doesn't contain a full field. Only field_id and type.
      //       so we have to look at the values to dertermine if we're working
      //       with a date or number calculation field
      if (this.field.get('type') === 'calculation') {
        if (!currentFilterValues) {
          currentFilterValues = [];
        } else if (currentFilterValues[0].value.id || _.isNumber(currentFilterValues[0].value.from)) {
          currentFilterValues = this.formatCurrentValuesForRangeValues(currentFilterValues);
        } else {
          currentFilterValues = this.formatCurrentValuesForDateFields(currentFilterValues);
        }
      }

      if( _.include(['date', 'created_on', 'last_edit_on'], this.field.get('type')) ) {
        currentFilterValues = this.formatCurrentValuesForDateFields(currentFilterValues);
      }

      if( _.include(['progress', 'number', 'money', 'duration'], this.field.get('type')) ) {
        currentFilterValues = this.formatCurrentValuesForRangeValues(currentFilterValues);
      }

      var pickerValues = _.map(currentFilterValues, function(item, key) {
        return this.formatValueForPicker(this.getFormattedItem(item));
      }, this);

      return _.compact(pickerValues);

    },

    getValuesFromLocation : function(filtersState, id) {
      return !filtersState.attributes.filters ? [] : filtersState.attributes.filters

        .filter(function(filter) {
          return filter.field_type === 'location' || filter.field_type.indexOf(':');
        })

        .map(function(filter) {
          if (filter.key === id) {
            return filter.humanized_values;
          }
          return filter.humanized_values.filter(function(hvalue) {
            return hvalue.value.key === id;
          });
        })

        .reduce(function(acc, x) {
          return x === undefined ? acc : acc.concat(x);
        }, []);

    }

  });

});


